const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const ColorUtil = require("../core/util/ColorUtil");
const colors = ColorUtil.getCurrentScheme();

const styles = require("./styles/CircleSequenceButtons.css");

module.exports = createReactClass({
	displayName: "CircleSequenceButtons",

	propTypes: {
		//An array of objects with properties title and description.
		titles: PT.arrayOf(PT.string),
		onClick: PT.func.isRequired,
		selectedIndex: PT.number.isRequired,
		numSections: PT.number.isRequired,

		className: PT.string,
		preventTitleCollapse: PT.bool,
		inactiveIndexes: PT.array,

		//Visual options:
		colorScheme: PT.oneOf([
			"white",
			"blue",
			"cyan",
			"grade-2",
			"grade-3",
			"grade-4",
			"grade-5",
		]),
		titlesBelow: PT.bool,
	},

	getDefaultProps: function() {
		return {
			titlesBelow: false,
		};
	},

	getStyleProps: function() {
		const {colorScheme} = this.props;
		let styleProps;

		if (colorScheme === "white") {
			styleProps = {
				lineColor: colors.circleWhiteLine,
				titleColor: colors.white,
				circleBackgroundColor: colors.mainBlue,
				circleBorderColor: colors.circleWhiteBorder,
				circleGlowColor: colors.circleWhiteGlow,
				selectedColor: colors.yellow,
				selectedGlowColor: colors.circleYellowGlow,
			};
		} else if (colorScheme === "cyan") {
			styleProps = {
				lineColor: colors.circleWhiteLine,
				titleColor: colors.white,
				circleBackgroundColor: colors.red,
				circleBorderColor: colors.circleWhiteBorder,
				circleGlowColor: colors.circleWhiteGlow,
				selectedColor: colors.cyan,
				selectedGlowColor: colors.circleCyanGlow,
			};
		} else {
			styleProps = {
				lineColor: colors.circleGrayLine,
				titleColor: colors.textBlack,
				circleBackgroundColor: colors.white,
				circleBorderColor: colors.circleGrayBorder,
				circleGlowColor: colors.circleGrayGlow,
			};

			if (_.startsWith(colorScheme, "grade-")) {
				const gradeNum = colorScheme.substring("grade-".length);
				const gradeColor = ColorUtil.getGradeColor(gradeNum);

				styleProps.selectedColor = gradeColor;
				styleProps.selectedGlowColor = ColorUtil.hexToRGBA(gradeColor, 0.2);
			} else if (colorScheme === "blue") {
				const red = colors.red;
				styleProps.selectedColor = red;
				styleProps.selectedGlowColor = ColorUtil.hexToRGBA(red, 0.2);
			}
		}

		return styleProps;
	},

	renderSectionSelector: function(sectionIndex) {
		const styleProps = this.getStyleProps();

		const buttonStyle = {};
		const circleStyle = {
			backgroundColor: styleProps.circleBackgroundColor,
			borderColor: styleProps.circleBorderColor,
		};
		const circleGlowStyle = {
			backgroundColor: styleProps.circleGlowColor,
		};

		const inactiveIndexes = this.props.inactiveIndexes || [];

		const buttonClass = styles.button;
		if (sectionIndex === this.props.selectedIndex) {
			circleStyle.backgroundColor = styleProps.selectedColor;
			circleStyle.borderColor = styleProps.selectedColor;
			circleGlowStyle.backgroundColor = styleProps.selectedGlowColor;
			delete buttonStyle.cursor;
			buttonStyle.color = styleProps.selectedColor;
		}

		if (_.includes(inactiveIndexes, sectionIndex)) {
			circleStyle.backgroundColor = colors.circleInactive;
			circleStyle.borderColor = colors.circleInactive;
			buttonStyle.color = colors.circleInactive;
		} else {
			buttonStyle.cursor = "pointer";
		}

		const lineStyle = {backgroundColor: styleProps.lineColor};
		const leftLine =
			sectionIndex > 0 ? (
				<div className={styles.leftL} style={lineStyle} />
			) : null;
		const rightLine =
			sectionIndex < this.props.numSections - 1 ? (
				<div className={styles.rightL} style={lineStyle} />
			) : null;

		const titleClass = this.props.preventTitleCollapse
			? styles.staticButtonTitle
			: styles.buttonTitle;

		let title = "";
		if (this.props.titles) title = this.props.titles[sectionIndex];

		const titleStyle = {color: styleProps.titleColor};

		return (
			<div
				className={buttonClass}
				key={"section-button-" + sectionIndex}
				onClick={() => this.props.onClick(sectionIndex)}
				style={buttonStyle}
			>
				<div className={titleClass} style={titleStyle}>
					{title}
				</div>
				{leftLine}
				<div className={styles.container}>
					<div className={styles.circle} style={circleStyle}>
						<div className={styles.glow} style={circleGlowStyle} />
					</div>
				</div>
				{rightLine}
			</div>
		);
	},

	render: function() {
		const sectionButtons = _.map(_.range(this.props.numSections), i =>
			this.renderSectionSelector(i)
		);

		let mainClass = styles.buttons;
		if (this.props.titlesBelow) mainClass += " " + styles.buttonsTitleBelow;
		if (this.props.className) mainClass += " " + this.props.className;

		return <div className={mainClass}>{sectionButtons}</div>;
	},
});
